import React from 'react';
import { useP } from '../i18n/useP';
import SegmentedToggle from './SegmentedToggle';
import './PersonFilterBar.css';

// Barre de filtre standard des tables de personnes :
// recherche (prénom, nom, département) + département + bascule Tous / Actifs.
// `status` : 'active' | 'all' — masquer la bascule avec showStatus={false}.
// « Tous » est le DÉFAUT et vient en premier (décision 2026-08-27) : la vue
// complète est l'état normal, « Actifs » est ce qu'on choisit de restreindre.
// `depts` : liste de départements → affiche le sélecteur. La recherche libre
// trouvait déjà un département, mais il fallait connaître son orthographe :
// le sélecteur montre CE QUI EXISTE, ce qu'un champ de saisie ne fait pas.
export default function PersonFilterBar({
  search, onSearch,
  status, onStatus, showStatus = true,
  dept, onDept, depts = null,
  placeholder,
  searchLabel = null,
}) {
  const p = useP();
  return (
    <div className="pfb">
      {searchLabel && <span className="lk-filter-lbl">{searchLabel}</span>}
      <input
        className="lk-filter-input pfb-search"
        type="search"
        value={search}
        onChange={e => onSearch(e.target.value)}
        placeholder={placeholder || p('Rechercher…')}
      />
      {depts && depts.length > 0 && (
        <select
          className="lk-filter-select pfb-select"
          value={dept || 'all'}
          onChange={e => onDept(e.target.value)}
          aria-label={p('Département')}
        >
          <option value="all">{p('Tous les départements')}</option>
          {depts.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      )}
      {showStatus && (
        /* « Actifs » TRONQUE la liste : les totaux ne portent alors qu'une
           partie de l'effectif. C'est l'état qui doit se voir — d'où le ton
           d'alerte, réservé à ce bouton (2026-08-23). Costume : bascule
           segmentée standard (2026-08-26). */
        <SegmentedToggle
          value={status}
          onChange={onStatus}
          ariaLabel={p('Effectif affiché')}
          options={[
            { value: 'all', label: p('Tous') },
            { value: 'active', label: p('Actifs'), tone: 'alert' },
          ]}
        />
      )}
    </div>
  );
}
